module.exports = __webpack_public_path__ + "img/x-box-image-detail-2.6b56f32c.png";